import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { ApplicableCoursePayload, SearchApplicableCoursePayload } from '../models/courseOrderLimit';

export const courseOrderLimitService = {
  getCourseOrderLimitList(payload: SearchApplicableCoursePayload): Promise<CommonResponse<any[]>> {
    const url = `/course-order-limit`;
    const params = new URLSearchParams();

    // Add query parameters if values are non-empty
    if (payload.menuBookName?.trim()) {
      params.append('mnb_name', payload.menuBookName.trim());
    }
    if (payload.courseName?.trim()) {
      params.append('c_name', payload.courseName.trim());
    }
    if (payload.limitType?.toString().trim()) {
      params.append('limit_type', payload.limitType.toString().trim());
    }
    if (payload.courseId?.toString().trim()) {
      params.append('course_id', payload.courseId.toString().trim());
    }
    const queryString = params.toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;

    return axiosClient.get(fullUrl);
  },

  addCourseOrderLimit(payload: ApplicableCoursePayload[]): Promise<CommonResponse<any>> {
    const url = `/course-order-limit`;
    return axiosClient.post(url, payload);
  },

  deleteCourseOrderLimit(payload: ApplicableCoursePayload[]): Promise<CommonResponse<any>> {
    const url = `/course-order-limit`;
    return axiosClient.delete(url, { data: payload });
  },
};
